<template>
  <div class="modal" :class="{ 'is-active': showModal }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button
          class="delete"
          aria-label="close"
          @click="showModal = false"
        ></button>
      </header>
      <section class="modal-card-body">
        {{ message }}
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" @click="resolve">
          {{ confirmText }}
        </button>
        <button class="button" @click="reject">
          Cancel
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Confirm?"
    },
    message: {
      type: String,
      default: null
    },
    confirmText: {
      type: String,
      default: "Yes"
    }
  },
  data() {
    return {
      showModal: false,
      resolve: () => {},
      reject: () => {}
    };
  },
  methods: {
    show() {
      this.showModal = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      }).finally(() => (this.showModal = false));
    }
  }
};
</script>

<style scoped>
.modal.is-active .modal-background {
  background: rgba(10, 10, 10, 0.86);
  border-radius: 0;
  width: 100%;
  height: 100%;
  transform: none;
  -webkit-transform: none;
}

.modal.is-active .modal-card {
  z-index: 99;
}
</style>